var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1192"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1192"
    },
    "bundlingPackage": "InpageEditorUI",
    "bundlingPackageVersion": "static-1.85919",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};